import React, { useState, useEffect } from 'react';
import Select from "react-select";
import SelectSearch, { fuzzySearch } from "react-select-search";
import LeftMenu from '../components/LeftMenu';
import TopBar from '../components/TopBar';
import DatePicker from 'react-date-picker';
import BootstrapTable from 'react-bootstrap-table-next';
import Breadcrumbs from '../components/Breadcrumbs';
import paginationFactory from 'react-bootstrap-table2-paginator';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import filterFactory, { textFilter, customFilter } from 'react-bootstrap-table2-filter';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';
import PropTypes from 'prop-types';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import '../style/custom.css';
import configData from '../configData.json';

export default function UserDetails() {

    const [userDetailsdata, setUserDetailsData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);


    const columns = [
        {
            dataField: 'id',
            text: 'Id',
            headerStyle: { width: '50' },
            hidden: true,
        },
        {
            dataField: 'username',
            text: 'User Name',
            headerStyle: { width: '25px', textAlign: 'center' },
            style: { textAlign: 'center' } // Align data center

        },
        {
            dataField: 'name',
            text: 'Name',
            headerStyle: { width: '25px', textAlign: 'center' },
            style: { textAlign: 'center' } // Align data center

        },
        {
            dataField: 'emailAddress',
            text: 'Email Address',
            headerStyle: { width: '35px', textAlign: 'center' },
            style: { textAlign: 'center' } // Align data center

        },

        {
            dataField: 'approved',
            text: 'Approved',
            headerStyle: { width: '25px', textAlign: 'center' },
            style: { textAlign: 'center' },
            headerFormatter: () => (
                <div>
                    Approved
                    <br />
                    <input
                        type="checkbox"
                        checked={userDetailsdata.length > 0 && userDetailsdata.every((user) => user.approved)}
                        onChange={handleSelectAllRows}
                    />
                </div>
            ),
            formatter: (cellContent, row) => (
                <input
                    type="checkbox"
                    checked={row.approved}
                    onChange={() => handleApprovalChange(row.username)}
                />
            )
        }


    ];

    const handleSelectAllRows = (event) => {
        debugger;
        const isChecked = event.target.checked;
        const updatedData = userDetailsdata.map((user) => ({
            ...user,
            approved: isChecked,
        }));

        setUserDetailsData(updatedData);
        setSelectedRows(isChecked ? updatedData.map((user) => user.id) : []);
    };

    const handleApprovalChange = (username) => {
        debugger;
        setUserDetailsData((prevData) => {
            const updatedData = prevData.map((user) => {
                if (user.username === username) {
                    const newApprovedStatus = !user.approved;
                    return { ...user, approved: newApprovedStatus };
                }
                return user;
            });

            setSelectedRows(updatedData.filter((user) => user.approved).map((user) => user.username));

            return updatedData;
        });
    };


    // useEffect(() => {
    //     // Update the selectedRows state whenever userDetailsdata changes
    //     const updatedSelectedRows = userDetailsdata
    //         .filter((user) => user.approved)
    //         .map((user) => user.id);

    //     setSelectedRows(updatedSelectedRows);

    // }, [userDetailsdata]);

    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])

    useEffect(() => {
        LoadUserDetailsData(); // Call the function on page load
    }, []); // Empty dependency array ensures it runs only once on mount

    const LoadUserDetailsData = async () => {

        setLoading(true);
        setUserDetailsData([]);
        const URL = `${configData.BASE_APP_URL}Login/GetUnApprovedUsers`;
        console.log(URL);
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => setUserDetailsData(resp));
        setLoading(false);
    }

    const handleApproveButtonClick = async () => {
        debugger;
        const approvedUsers = userDetailsdata.filter((user) => user.approved);
        if (approvedUsers.length === 0) {
            // No users selected for approval
            alert('Please select at least one user to approve.');
            return;
        }

        const approvedUserIds = approvedUsers.map((user) => user.id);

        try {
            const approvedBy = sessionStorage.getItem('my-username');
            const payload = approvedUsers.map((user) => ({
            Username: user.username,
            Approved: user.approved,
            ApprovedBy: approvedBy,
            EmailAddress: user.emailAddress,
        }));

            const response = await fetch(`${configData.BASE_APP_URL}Login/ApproveUsers`, {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token'),
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                // Handle error responses here
                const errorMessage = await response.text();
                alert(`Error: ${errorMessage}`);
                return;
            }

            // Handle success response here
            alert('Users approved successfully!');
            LoadUserDetailsData(); // Refresh the user details data after approval
        } catch (error) {
            // Handle any other errors that may occur during the fetch
            alert('An error occurred while calling the API.');
        }
    };



    return (
        <>
            <div className='st1'>
                <LeftMenu />
                <div className="mcw">
                    <TopBar />

                    <div className='pt-1 px-3 pb-3 py-3'>

                        <Breadcrumbs title="User Details" />

                        <div className="row">

                            <div className='col-2'></div>

                            <div className="col-8">


                                <div className="panel panel-default mb-1">
                                    {/* <div className="panel-header justify-content-between p-2 search-panel-header">
                                <span>User Details</span>
                            </div> */}

                                    <div className="panel-body border-top-0 border rounded-bottom p-2">

                                        <div className="row px-2 mb-2">

                                            <div className="col-12">

                                                <div className='custom-table-text user-table'>

                                                    <BootstrapTable
                                                        classes='table table-striped table-hover'
                                                        headerClasses='table-top'
                                                        keyField="id" // Use index as the key
                                                        data={userDetailsdata}
                                                        columns={columns}
                                                    />


                                                </div>

                                            </div>



                                        </div>

                                        <div className="row px-2">
                                            <div className='col-12 text-center'>
                                                <button className='btn btn-filter' onClick={handleApproveButtonClick}>Approve</button>
                                            </div>
                                        </div>



                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
